module.exports = __webpack_public_path__ + "static/media/icn-checkmark.dbc71b57.svg";